import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import EmojiPicker, { EmojiClickData, EmojiStyle } from 'emoji-picker-react';
import {stemoj,openemoji} from './userdefaultdata'; 
function EmojiPickercomp() {
  const [chosenEmoji, setChosenEmoji] = useState<string | null>(null);

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    setChosenEmoji(emojiData.emoji);
    // You can also access other properties like emojiData.unified, emojiData.names, etc.
    const emoji = emojiData.emoji; 
    stemoj(emoji);
    
  };

  return (
    <div className="Emojipic">
      <EmojiPicker 
        onEmojiClick={handleEmojiClick} 
        emojiStyle={EmojiStyle.NATIVE} // Or GOOGLE, TWITTER, etc.
      />
     
    </div>
  );
}

export default EmojiPickercomp;
